// src/hooks/usePageSettings.ts
// Hand the open page's settings to the Right Rail, so the panel can show
// expanded what the navbar's menu folds behind one button.
//
// The same handover as usePageActions, and per tab for the same reason: several
// pages are mounted at once, and the panel serves the one in front.
//
// What is handed over is a rendered node. The rail is a sibling of the panes,
// under none of their providers, so the page wraps its settings in the contexts
// they read — that is the page's job, not the panel's.

import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useTabId } from '@/components/tabs/TabContext';
import { railStore } from '@/stores/RailStore';

export function usePageSettings(settings: ReactNode) {
  const tabId = useTabId();

  useEffect(() => {
    railStore.setPageSettings(tabId, settings);
  }, [tabId, settings]);

  useEffect(() => () => railStore.clearPageSettings(tabId), [tabId]);
}
